// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { BurnRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { ContractId } from '@daml/types';
import { RowNew } from '../../../../components/Table/types';
import { useAcceptBurn2Step } from './useAcceptBurnRequest2Step';
import { useCancelBurnRequest2Step } from './useCancelBurnRequest2Step';
import { useRejectBurnRequest2Step } from './useRejectBurnRequest2Step';

type ContractId2Step = ContractId<BurnRequest>;

export const useGetBurnChoices = (onSuccess?: () => void, selectedRow?: RowNew) => {
  const acceptBurnRequest2Step = useAcceptBurn2Step();
  const cancelBurnRequest2Step = useCancelBurnRequest2Step();
  const rejectBurnRequest2Step = useRejectBurnRequest2Step();

  const contractId = selectedRow?.contractId;

  const onAccept = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    await acceptBurnRequest2Step({ burnRequestId: contractId as ContractId2Step });
    onSuccess?.();
  };

  const onReject = async (reason: string) => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    await rejectBurnRequest2Step({
      burnRequestId: contractId as ContractId2Step,
      reason,
    });
    onSuccess?.();
  };

  const onCancel = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    await cancelBurnRequest2Step({
      burnRequestId: contractId as ContractId2Step,
    });
    onSuccess?.();
  };
  return {
    onAccept,
    onReject,
    onCancel,
  };
};
